import { render, staticRenderFns } from "./object.vue?vue&type=template&id=a4128d14"
import script from "./object.vue?vue&type=script&lang=ts"
export * from "./object.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports